import { c as _c } from "react/compiler-runtime";
import { usePageView } from '@/analytics/pageTypes';
import { SeoHeader } from '@/components/SeoHeader';
import { Layout } from '@/components/layout';
import Hero from '@/sections/Hero';
import { getIntlProps, type IntlProps } from '@/utils/intl';
import type { GetStaticProps } from 'next';
import { Trans, useTranslation } from 'react-i18next';
import React from 'react';
import { MoreInfo } from '@/sections/xmas/MoreInfo';
import { Gifts } from '@/sections/xmas/Gifts';
import { HowItWorks } from '@/sections/xmas/HowItWorks';
import { Sales } from '@/sections/xmas/Sales';
import { Faqs } from '@/sections/xmas/Faqs';
import { getPageBannerWithPromoSourceBySlug, PageBanner } from '@/api/sanity/pageBanners';
import { EshopsList, getAffiliateEshopsList } from '@/api/sanity/affiliateEshopsList';
import { AnimatedSection, AnimatedContent } from '@/components/animation';
import { LINKS } from '@/constants/links';
import Eshops from '@/sections/Eshops';
import { Link } from '@/components/links';
import usePromoSource from '@/hooks/usePromoSource';
import { useClientOnly } from '@/hooks/useClientOnly';
import { isAllowedRoute } from '@/lang/pagesConfig';
import { RepresentativeExample } from '@/sections/RepresentativeExample';
import { getAllPageMenuPromoBanners, PageMenuPromoBanner } from '@/api/sanity/pageMenuPromoBanner';
import { getSectionAnchorId } from '@/utils/anchors';
interface Props extends IntlProps {
  pageBanners: PageBanner[] | null;
  eshops: EshopsList;
  menuPromoBanners?: PageMenuPromoBanner[];
}
export default function Page(t0) {
  const $ = _c(53);
  const {
    pageBanners,
    eshops,
    menuPromoBanners
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["xmas", "core"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  const promoSource = usePromoSource();
  const {
    isClient
  } = useClientOnly();
  usePageView("xmas");
  let t2;
  if ($[1] !== isClient || $[2] !== pageBanners || $[3] !== promoSource) {
    t2 = isClient && promoSource && pageBanners?.find(banner_0 => banner_0.promoSource === promoSource) || pageBanners?.find(_temp);
    $[1] = isClient;
    $[2] = pageBanners;
    $[3] = promoSource;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const pageBanner = t2;
  let t3;
  if ($[5] !== t) {
    t3 = t("seo.title");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t) {
    t4 = t("seo.description");
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <SeoHeader title={t3} description={t4} />;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const t6 = pageBanner?.videoId;
  let t7;
  if ($[12] !== pageBanner?.title || $[13] !== t) {
    t7 = pageBanner?.title ?? t("banner.title");
    $[12] = pageBanner?.title;
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== pageBanner?.text || $[16] !== t) {
    t8 = pageBanner?.text ?? <Trans t={t} i18nKey="banner.text"><Link testId="xmasShopWisely" analyticsParam="xmasShopWisely" to={LINKS().shopWisely} /></Trans>;
    $[15] = pageBanner?.text;
    $[16] = t;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== pageBanner || $[19] !== t) {
    t9 = pageBanner ? pageBanner.buttons : [{
      ariaLabel: t("banner.cta"),
      label: t("banner.cta"),
      to: LINKS().registration,
      testId: "xmasCta",
      analyticsParam: "xmasCta",
      variant: "primary"
    }];
    $[18] = pageBanner;
    $[19] = t;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  const t10 = pageBanner?.variant || "mockupMobile";
  const t11 = pageBanner?.image?.url ?? "/images/sections/xmas/hero/cs/hero.png";
  let t12;
  if ($[21] !== pageBanner?.image?.alt || $[22] !== t) {
    t12 = pageBanner?.image?.alt ?? t("banner.title");
    $[21] = pageBanner?.image?.alt;
    $[22] = t;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t11 || $[25] !== t12) {
    t13 = {
      url: t11,
      alt: t12
    };
    $[24] = t11;
    $[25] = t12;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t10 || $[28] !== t13 || $[29] !== t6 || $[30] !== t7 || $[31] !== t8 || $[32] !== t9) {
    t14 = <Hero videoId={t6} title={t7} text={t8} buttons={t9} variant={t10} image={t13} />;
    $[27] = t10;
    $[28] = t13;
    $[29] = t6;
    $[30] = t7;
    $[31] = t8;
    $[32] = t9;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = getSectionAnchorId("offer");
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <AnimatedContent><Gifts /></AnimatedContent>;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <AnimatedContent><HowItWorks /></AnimatedContent>;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <div className="mx-auto max-w-192"><AnimatedContent><RepresentativeExample /></AnimatedContent></div>;
    $[37] = t18;
  } else {
    t18 = $[37];
  }
  let t19;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <AnimatedSection bgColor="bg-blue-100" className="flex flex-col gap-20 lg:gap-40" id={t15}>{t16}{t17}{t18}<AnimatedContent><Sales /></AnimatedContent></AnimatedSection>;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  let t20;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = getSectionAnchorId("eshops");
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  let t21;
  if ($[40] !== eshops || $[41] !== t) {
    t21 = eshops.length > 0 && <Eshops eshops={eshops} title={t("eshopList")} hideText={true} />;
    $[40] = eshops;
    $[41] = t;
    $[42] = t21;
  } else {
    t21 = $[42];
  }
  let t22;
  if ($[43] !== t21) {
    t22 = <AnimatedSection bgColor="bg-blue-50" id={t20}><AnimatedContent><div>{t21}</div></AnimatedContent></AnimatedSection>;
    $[43] = t21;
    $[44] = t22;
  } else {
    t22 = $[44];
  }
  let t23;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = getSectionAnchorId("moreInfo");
    $[45] = t23;
  } else {
    t23 = $[45];
  }
  let t24;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <AnimatedContent><Faqs /></AnimatedContent>;
    $[46] = t24;
  } else {
    t24 = $[46];
  }
  let t25;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <AnimatedSection bgColor="bg-blue-100" className="flex flex-col gap-20 lg:gap-40" id={t23}>{t24}<AnimatedContent><MoreInfo /></AnimatedContent></AnimatedSection>;
    $[47] = t25;
  } else {
    t25 = $[47];
  }
  let t26;
  if ($[48] !== menuPromoBanners || $[49] !== t14 || $[50] !== t22 || $[51] !== t5) {
    t26 = <Layout menuPromoBanners={menuPromoBanners}>{t5}{t14}{t19}{t22}{t25}</Layout>;
    $[48] = menuPromoBanners;
    $[49] = t14;
    $[50] = t22;
    $[51] = t5;
    $[52] = t26;
  } else {
    t26 = $[52];
  }
  return t26;
}
function _temp(banner) {
  return !banner.promoSource;
}
export const getStaticProps = (async ctx => {
  const isAllowed = isAllowedRoute('zaplatim-po-vanocich');
  if (!isAllowed) {
    return {
      notFound: true
    };
  }
  return {
    props: {
      pageBanners: await getPageBannerWithPromoSourceBySlug('xmas'),
      eshops: await getAffiliateEshopsList('xmas'),
      menuPromoBanners: await getAllPageMenuPromoBanners(),
      ...(await getIntlProps(ctx, ['core', 'eshops', 'xmas']))
    }
  };
}) satisfies GetStaticProps<Props>;